// extracted by mini-css-extract-plugin
export default {"contact":"contacts_contact__JtvKF"};